import { z } from "zod";

export const ReportStatusSchema = z.enum([
  "TRANSCRIBING",
  "GENERATING",
  "DRAFT",
  "VALIDATED",
  "FAILED",
]);

export type ReportStatus = z.infer<typeof ReportStatusSchema>;

export const ReportUpdateSchema = z.object({
  title: z.string().max(200).nullable().optional(),
  reportContent: z.record(z.unknown()).optional(),
});

export type ReportUpdateDto = z.infer<typeof ReportUpdateSchema>;

export const ReportListItemSchema = z.object({
  id: z.string().cuid(),
  clientId: z.string().cuid(),
  appointmentId: z.string().cuid().nullable(),
  status: ReportStatusSchema,
  title: z.string().nullable(),
  audioDurationSec: z.number().int().nullable(),
  errorMessage: z.string().nullable(),
  validatedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type ReportListItem = z.infer<typeof ReportListItemSchema>;
